import { Badge, Box, Loader, Stack, Table, Text } from '@mantine/core';

import { useGetUserDataDeletionAuditLogs } from '../api';
import { STATUS_CONFIG } from '../constants';

import { formatDateTimeUTC } from '@/utils/dates';

export const UserDataDeletionAuditLogPage = () => {
  const { data, isLoading } = useGetUserDataDeletionAuditLogs();

  if (isLoading) {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loader size="xl" />
      </Box>
    );
  }

  return (
    <Box>
      <Table stickyHeader striped highlightOnHover withColumnBorders withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>File name</Table.Th>
            <Table.Th>Upload date</Table.Th>
            <Table.Th>User IDs in file</Table.Th>
            <Table.Th>Matched user IDs</Table.Th>
            <Table.Th>Deleted records</Table.Th>
            <Table.Th>Status</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data?.logs.map((log) => (
            <Table.Tr key={log._id}>
              <Table.Td>{log.fileName}</Table.Td>
              <Table.Td>{formatDateTimeUTC(log.uploadedAt)}</Table.Td>
              <Table.Td>{log.idsInFile}</Table.Td>
              <Table.Td>
                <Stack>
                  <Text>Matched Dialogs: {log.matchedDialogsCount}</Text>
                  <Text>Matched Messages: {log.matchedMessagesCount}</Text>
                  <Text>Matched Total: {log.matchedDialogsCount + log.matchedMessagesCount}</Text>
                </Stack>
              </Table.Td>
              <Table.Td>
                <Stack>
                  <Text>Deleted Dialogs: {log.deletedDialogsCount}</Text>
                  <Text>Deleted Messages: {log.deletedMessagesCount}</Text>
                  <Text>Deleted Total: {log.deletedDialogsCount + log.deletedMessagesCount}</Text>
                </Stack>
              </Table.Td>
              <Table.Td>
                <Table.Td>
                  <Badge color={STATUS_CONFIG[log.status].color} variant="light" radius="sm">
                    {STATUS_CONFIG[log.status].label}
                  </Badge>
                </Table.Td>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
};
